import React, { Component } from 'react';
import Button from 'common/components/Button';
import Select from 'react-select';

import { localeStrings as strings } from 'applicationConfig';
import publisherTypes from '../../common/constants/publisherTypes';

class ReportingDownloadGridRow extends Component {
  state = {
    selectedOption: '',
  };

  handleChange = (selectedOption) => {
    this.setState({ selectedOption });
  };

  renderSimpleRow(key, name, path, className) {
    const classes = ['execution-reporting-grid-row', 'field-group', 'simple-row', className].join(' ');
    return (
      <div className={classes} key={key}>
        <div className="field-group-label">{name}</div>
        <div className="actions">
          <Button
            className="btn btn-primary"
            onClick={() => this.props.onClick(path)}>
            <span className="button-caption">{strings.executionReportingDownload.download}</span>
          </Button>
        </div>
      </div>
    );
  }

  renderSimpleRows(reports, className) {
    return (<div>
      {reports.map((report, index) => this.renderSimpleRow(index, report.label, report.value, className))}
    </div>);
  }

  renderRowWithSelect(name, description, options) {
    const { selectedOption } = this.state;
    return (
      <div className="execution-reporting-grid-row field-group selectable-row">
        <div className="field-group-label">{name} <span className="description" title={description}>{description}</span></div>
        <div className="field-group-value">
          <Select
            clearable={true}
            className="tpi-select"
            value={selectedOption}
            onChange={this.handleChange}
            options={options}
            isLoading={false}
            disabled={false}
          />
        </div>
        <div className="actions">
          <Button
            className="btn btn-primary"
            disabled={!selectedOption}
            onClick={() => this.props.onClick(selectedOption.value)}>
            <span className="button-caption">{strings.executionReportingDownload.download}</span>
          </Button>
        </div>
      </div>
    );
  }

  render() {
    const { name, description, options } = this.props.data;
    const isInvestmentFirm = this.props.type === publisherTypes.investmentFirm;
    const className = isInvestmentFirm ? 'investment-firm' : 'trading-venue';
    if (isInvestmentFirm) {
      return this.renderSimpleRows(options, className);
    }
    return !name
      ? this.renderSimpleRows(options, className)
      : this.renderRowWithSelect(name, description, options);
  }
}

export default ReportingDownloadGridRow;



// WEBPACK FOOTER //
// ./src/containers/ReportingDownload/ReportingDownloadGridRow.jsx